import { render, staticRenderFns } from "./DemandePermisPharmacienEquivalence.vue?vue&type=template&id=06452632"
import script from "./DemandePermisPharmacienEquivalence.vue?vue&type=script&lang=js"
export * from "./DemandePermisPharmacienEquivalence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports